
import { FrankApiSettingsForm } from './frank-settings';

const FrankApiSettings = () => {
  return <FrankApiSettingsForm />;
};

export default FrankApiSettings;
